module.exports = __webpack_public_path__ + "img/Renewing Forgotten Flows.76ca7b13.jpg";